<div class="spacer">
  <nav class="links">
    <ul class="unstyled">
      <li>
        <a class="skip" (click)="skipNavigationContent($event)" href="/">Skip navigationsindhold</a>
      </li>

      @if (!hideGroceries) {
        <li>
          <a class="nav products" [routerLink]="groceries.url" routerLinkActive="active">
            {{ groceries.name }}
            <mat-icon class="arrow" svgIcon="left_arrow"></mat-icon>
          </a>
        </li>
      }

      @for (link of links; track $index) {
        @if (link.type === 'link') {
          <li>
            @if (sameSite(link); as link) {
              <a class="nav" [routerLink]="link.targetUrl" routerLinkActive="active" [target]="link.new ? '_blank' : '_self'">
                {{ link.titleText }}
                <mat-icon class="arrow" svgIcon="left_arrow"></mat-icon>
              </a>
            }
            @if (!sameSite(link)) {
              <a class="nav" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'">
                {{ link.titleText }}
                <mat-icon class="arrow" svgIcon="left_arrow"></mat-icon>
              </a>
            }
          </li>
        }
        @if (link.type === 'subNav') {
          <div class="sub-nav">
            <li>
              <a
                class="nav"
                [class.no-pointer]="!link.link"
                [class.open]="openNavigationName === link.title"
                (mouseenter)="openNavigation(navContent, link.title)"
                (focus)="openNavigation(navContent, link.title)"
                [routerLink]="link.link ? [link.link] : []"
                [routerLinkActive]="link.link ? 'active' : ''"
                (click)="link.link && closeNavigation()"
                [target]="link.linkTarget"
                tabindex="0"
              >
                {{ link.title }}
              </a>
            </li>
            <div class="sub-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
              <div>
                @for (link of link.pages; track $index) {
                  <li>
                    @if (sameSite(link); as sameSiteLink) {
                      <a
                        class="nav small white"
                        [routerLink]="sameSiteLink.targetUrl"
                        routerLinkActive="active"
                        [target]="sameSiteLink.new ? '_blank' : '_self'"
                        (click)="closeNavigation()"
                        >{{ sameSiteLink.titleText }}
                      </a>
                    }
                    @if (!sameSite(link)) {
                      <a
                        class="nav small white"
                        [href]="link.targetUrl"
                        [target]="link.new ? '_blank' : '_self'"
                        (click)="closeNavigation()"
                        >{{ link.titleText }}
                      </a>
                    }
                  </li>
                }
              </div>
            </div>
          </div>
        }

        @if (link.type === 'burger') {
          <div class="burger-nav">
            <li>
              <a
                class="nav"
                [class.no-pointer]="!link.link"
                [class.open]="openNavigationName === link.title"
                (mouseenter)="openNavigation(navContent, link.title)"
                (focus)="openNavigation(navContent, link.title)"
                [routerLink]="link.link ? [link.link] : []"
                [routerLinkActive]="link.link ? 'active' : ''"
                (click)="link.link && closeNavigation()"
                [target]="link.linkTarget"
                tabindex="0"
              >
                {{ link.title }}
              </a>
            </li>

            <div class="burger-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
              <div>
                @for (link of link.pages; track $index) {
                  <li>
                    @let sameSiteLink = sameSite(link);
                    @if (sameSiteLink) {
                      <a
                        class="nav white"
                        [routerLink]="sameSiteLink.targetUrl"
                        routerLinkActive="active"
                        [target]="sameSiteLink.new ? '_blank' : '_self'"
                        (click)="closeNavigation()"
                        >{{ sameSiteLink.titleText }}
                      </a>
                    }
                    @if (!sameSiteLink) {
                      <a class="nav white" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'" (click)="closeNavigation()">
                        {{ link.titleText }}
                      </a>
                    }
                  </li>
                }
              </div>
            </div>
          </div>
        }

        @if (link.type === 'categoryBurger') {
          <div class="burger-nav">
            <li>
              <a
                class="nav"
                [class.no-pointer]="!link.link"
                [class.open]="openNavigationName === link.title"
                (mouseenter)="openNavigation(navContent, link.title)"
                (focus)="openNavigation(navContent, link.title)"
                [routerLink]="link.link ? [link.link] : []"
                [routerLinkActive]="link.link ? 'active' : ''"
                (click)="link.link && closeNavigation()"
                [target]="link.linkTarget"
                tabindex="0"
              >
                {{ link.title }}
              </a>
            </li>

            <div class="burger-nav-content" [class.display]="openNavigationName === link.title" tabindex="-1" #navContent>
              <div>
                @for (link of link.pages; track $index) {
                  <li>
                    @let sameSiteLink = sameSite(link);
                    @if (sameSiteLink) {
                      <a
                        class="nav white"
                        [routerLink]="sameSiteLink.targetUrl"
                        routerLinkActive="active"
                        [target]="sameSiteLink.new ? '_blank' : '_self'"
                        (click)="closeNavigation()"
                        >{{ sameSiteLink.titleText }}
                      </a>
                    }
                    @if (!sameSiteLink) {
                      <a class="nav white" [href]="link.targetUrl" [target]="link.new ? '_blank' : '_self'" (click)="closeNavigation()">
                        {{ link.titleText }}
                      </a>
                    }
                  </li>
                }
              </div>
            </div>
          </div>
        }
      }
    </ul>
  </nav>
  <div class="actions">
    @if (showShipping) {
      <button class="unstyled-button shipping" (click)="openShipping()" id="shipping">
        <mat-icon svgIcon="shop"></mat-icon> VÆLG AFHENTNING: DATO & TID
      </button>
    }
  </div>
</div>
